
<div class="row">
  <div class="col-md-6 mb-3 mt-3 form-group">
    <label>Attach file from candidate's profile</label>
    <div id="candidatefileInMail" class="row">
      <div class="col-10 no-padding-right">            
        <ng-select name="candidate-docs" (change)="onSelectingDoc($event)" [items]="candidateDocs"
                   bindLabel="fileName" bindValue="item" placeholder="Select file" multiple="true" #attachControl>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <div *ngIf="moduleType === moduleTypes.Exit && item.documentType.displayText" title="{{item.documentType.displayText}}"><span>{{ item.documentType.displayText }}</span></div>
            <div *ngIf="moduleType === moduleTypes.Preboarding || moduleType === moduleTypes.Immigration" title="{{item.documentTypeName}}"><span>{{ item.documentTypeName }}</span></div>
            <div title="{{item.fileName}}">
              <span><small><strong>{{item.fileName}}</strong></small></span>
              <span *ngIf="item.description"><small><strong> ({{item.description}})</strong></small></span>
              <span *ngIf="moduleType === moduleTypes.Preboarding && item.documentName"><small><strong> ({{item.documentName}})</strong></small></span>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-md-1 no-padding-left">
        <button type="button" [disabled]="selectedCandiFiles.length ===0"
                (click)="attachCandidateFilesToMail()" class="btn btn-secondary">
          <span>Attach</span>        
        </button>
      </div>
    </div>
  </div>
</div>
